import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@mdi/react';

// import cx from 'clsx';
import _set from 'lodash/set';

const styles = theme => ({
    root: {
        textTransform: 'none',
        cursor: 'pointer',
    },
    bold: {
        fontWeight: 500,
    },
});

const AfitdMdiIcon = props => {
    const { classes, isHidden, color: colorProp, ...otherProps } = props;

    let defns = {};

    switch (colorProp) {
        case 'primary': {
            _set(defns, 'color', '#FC821F');
            break;
        }
        case 'secondary': {
            _set(defns, 'color', '#1D8A8B');
            break;
        }
        case 'default': {
            _set(defns, 'color', 'rgba(0, 0, 0, 0.04)');
            break;
        }
        case 'disabled': {
            _set(defns, 'color', 'rgba(0, 0, 0, 0.26)');
            break;
        }
        case 'page-message': {
            _set(defns, 'color', 'rgba(216, 216, 216, 1)');
            break;
        }
        case 'watermark': {
            _set(defns, 'color', '#F0F2F6');
            break;
        }
        case 'inherit':
        default: {
            //do nothing
        }
    }

    if (isHidden) {
        return null;
    } else {
        return <Icon {...defns} {...otherProps} />;
    }
};

export default withStyles(styles)(AfitdMdiIcon);
